import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

// Pages
import Home from './pages/Home';
import Register from './pages/Register';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import GenerateQR from './pages/GenerateQR';
import AboutService from './pages/AboutService';
import ScanResult from './pages/ScanResult';
import QRSimulation from './pages/QRSimulation';

// Components
import Navigation from './components/Navigation';
import Footer from './components/Footer';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* QR Simulation route without header/footer */}
          <Route path="/simulation" element={<QRSimulation />} />
          
          {/* All other routes with header/footer */}
          <Route path="*" element={
            <>
              <Navigation />
              <main className="container mt-4">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/generate-qr" element={<GenerateQR />} />
                  <Route path="/about" element={<AboutService />} />
                  <Route path="/scan" element={<ScanResult />} />
                </Routes>
              </main>
              <Footer />
            </>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
